import { hasEntityDefined, isOneOfEntity } from './row-definition-helpers';

export const ENTITIES = {
  PRODUCT: 'Product',
  ALL_BRAND: 'AllBrand',
  CATEGORY: 'Category',
  COLLECTION: 'Collection',
  USER: 'User',
  CURATOR_GROUP: 'CuratorGroup'
};

export const POOL_REFINEMENT = {
  NONE: {
    label: 'Everything',
    allowedWhen: hasEntityDefined
  }
  // IN_CIRCLE: {
  //   label: "In user's circle",
  //   allowedWhen: isOneOfEntity([ENTITIES.USER, ENTITIES.PRODUCT])
  // }
};

export const FILTER_ENTITY = {
  NONE: {
    label: 'No filter',
    allowedWhen: hasEntityDefined
  },
  CATEGORY: {
    label: 'In a category',
    allowedWhen: isOneOfEntity([ENTITIES.PRODUCT]),
    filterKey: 'Category_id'
  },
  ALL_BRAND: {
    label: 'From a brand',
    allowedWhen: isOneOfEntity([ENTITIES.ALL_BRAND]),
    filterKey: 'Brand_id'
  },
  COLLECTION: {
    label: 'In a collection',
    allowedWhen: isOneOfEntity([ENTITIES.COLLECTION]),
    filterKey: 'Collection_id'
  }
};

// Selections are only relevant when an entity filter is applied
export const SELECTION = {
  // // TODO - implement
  // FIXED: {
  //   label: 'selected IDs',
  //   allowedWhen: definition => hasEntityDefined(definition) && definition.filterEntity !== 'NONE'
  // },
  PERSONALIZED: {
    label: 'personalized results',
    allowedWhen: definition => hasEntityDefined(definition) && definition.filterEntity !== 'NONE',
    filterKey: 'personalized'
  },
  RECENTLY_ENGAGED: {
    label: 'recently engaged results',
    allowedWhen: definition => definition.filterEntity !== 'NONE' && isOneOfEntity([ENTITIES.USER, ENTITIES.PRODUCT])(definition),
    filterKey: 'recently_engaged'
  }
};

export const SORT_RESULTS = {
  RELEVANCE: {
    label: 'Relevance',
    allowedWhen: hasEntityDefined,
    cardSortKey: 'personalized'
  }
};

export const TIMEFRAME = {
  ALL_TIME: {
    label: 'All time',
    allowedWhen: hasEntityDefined
  }
  // CREATED_AFTER_FIXED_DATE: {
  //   label: 'Created after fixed date',
  //   allowedWhen: hasEntityDefined
  // },
  // CREATED_AFTER_RELATIVE_DATES: {
  //   label: 'Created after x days ago',
  //   allowedWhen: hasEntityDefined
  // }
};

export const definitionAsRow = definition => {
  const row = {
    filter: {},
    cardSort: {},
    entity: definition.entity
  };

  if (definition.filterEntity === 'NONE') {
    row.filter = {};
  } else {
    const filterEntity = FILTER_ENTITY[definition.filterEntity];
    const selection = SELECTION[definition.selection];
    if (filterEntity && selection) {
      row.filter[filterEntity.filterKey] = {
        type: 'smart',
        filter_sort: selection.filterKey || 'personalized',
        option_limit: 3
      };
    }
  }

  const sortResults = SORT_RESULTS[definition.sortResults];
  if (sortResults) {
    row.cardSort = sortResults.cardSortKey || 'personalized';
  }

  return row;
};
